import { render, staticRenderFns } from "./upairy-card.vue?vue&type=template&id=0aaeae8a&scoped=true&"
import script from "./upairy-card.vue?vue&type=script&lang=js&"
export * from "./upairy-card.vue?vue&type=script&lang=js&"
import style0 from "./upairy-card.vue?vue&type=style&index=0&id=0aaeae8a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0aaeae8a",
  null
  
)

export default component.exports